module.exports = __webpack_public_path__ + "img/Farm Story.9e1f1f2f.png";